export default "__VITE_ASSET__8fc2cf7d__"